<template>
  <el-popover
    ref="popover"
    v-model="visible"
    placement="top"
    width="400">
    <el-form
      ref="ruleForm"
      label-width="100px"
      :model="form"
      :rules="rules">
      <el-form-item
        label="仓库类型："
        prop="productType">
        <el-radio-group v-model="form.productType">
          <el-radio-button :label="1">成品</el-radio-button>
          <el-radio-button :label="2">包材</el-radio-button>
          <el-radio-button :label="3">原料</el-radio-button>
          <el-radio-button :label="9">外购成品</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="仓库用途："
        prop="useType">
        <el-radio-group v-model="form.useType">
          <el-radio-button :label="1">普通仓库</el-radio-button>
          <el-radio-button :label="4">客户仓库</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div style="text-align: right; margin: 0">
      <el-button
        type="text"
        :loading="loading"
        @click="visible = false">取消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="submit">确定</el-button>
    </div>
    <i
      slot="reference"
      style="cursor: pointer;"
      class="el-icon-edit"></i>
  </el-popover>
</template>

<script>
export default {
  name: 'WarehouseSettingPopover',
  props: {
    callback: Function,
    id: Number,
    productType: {
      type: Number,
      default: 1
    },
    useType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      form: {
        productType: 1,
        useType: 1
      },
      rules: {
        productType: [{ required: true, message: '请选择仓库类型', trigger: 'change' }],
        useType: [{ required: true, message: '请选择仓库用途', trigger: 'change' }]
      }
    }
  },
  watch: {
    productType: {
      handler(val) {
        this.form.productType = val || null
      },
      immediate: true
    },
    useType: {
      handler(val) {
        this.form.useType = val || null
      },
      immediate: true
    }
  },
  methods: {
    submit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('outstock/updatewarehouse', {
            payload: {
              warehouseId: this.id,
              productType: this.form.productType,
              useType: this.form.useType
            },
            success: () => {
              this.callback && this.callback()
              this.$refs.popover.doClose()
              this.loading = false
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>

<style>

</style>
